'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   LinkIcon,
// } from '../../components'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _IyvListFilters = require('./IyvListFilters.css');

var _IyvListFilters2 = _interopRequireDefault(_IyvListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * UI component for the List container.
 * All state management is done in List container.
 *
 * Renders a list of buttons, each representing an active filter.
 * Clicking an active filter calls a remove() func.
 *  
 */
var IyvListActiveFilters = (_dec = (0, _reactCssModules2.default)(_IyvListFilters2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListActiveFilters, _Component);

  //
  function IyvListActiveFilters(props) {
    (0, _classCallCheck3.default)(this, IyvListActiveFilters);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListActiveFilters.__proto__ || (0, _getPrototypeOf2.default)(IyvListActiveFilters)).call(this, props));
  }
  //
  // COMMON


  (0, _createClass3.default)(IyvListActiveFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedFilters = _props.selectedFilters,
          searchQuery = _props.searchQuery,
          filterOptions = _props.filterOptions,
          removeFilter = _props.removeFilter,
          removeFilters = _props.removeFilters,
          removeSearchFilter = _props.removeSearchFilter,
          defaultFilter = _props.defaultFilter;


      var idx = 0;

      var renderActiveFilter = function renderActiveFilter(label, remove) {
        // create a <button> with custom label and custom remove method
        return _react2.default.createElement(
          'button',
          {
            key: idx++,
            styleName: 'active-filter',
            onClick: remove,
            role: 'button',
            tabIndex: '0'
          },
          _react2.default.createElement(
            'span',
            null,
            label
          ),
          _react2.default.createElement('span', { styleName: 'active-filter-remove', className: 'fa fa-remove' })
        );
      };

      // if there's a searchQuery, the first activeFilter is that query
      var activeFilters = searchQuery.trim() !== '' ? [renderActiveFilter('Search: ' + searchQuery, removeSearchFilter)] : [];

      activeFilters = activeFilters.concat((0, _entries2.default)(selectedFilters).filter(function (filter) {
        // filter out any selected filters that are set to the default.
        // anything set to the default filter, is not going to have an
        // "active filter" elem.
        return filter[1] && filter[1] !== defaultFilter;
      }).map(function (filter) {
        // go through each of the remaining filters; these should have
        // "active filter" elements so they can be removed.

        // find the option that matches this active filter
        var option = filterOptions(filter[0]).find(function (o) {
          return o.value + '' === filter[1] + '';
        });

        // if there is no option, don't create an "active filter" elem
        if (!option) {
          return null;
        }

        // otherwise create an "active filter" elem, so it can be removed
        return renderActiveFilter(option.label, removeFilter(filter[0]));
      }).filter(function (filter) {
        // remove anything that ended up as null somehow
        return filter !== null;
      }));

      // if there are no filters, just return a single "None" label
      if (activeFilters.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'active-filters' },
          _react2.default.createElement(
            'div',
            { styleName: 'active-filters-label' },
            'Active filters:'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'active-filter-none' },
            'None'
          )
        );
      }

      // otherwise, we have filters. Add a "clear filters" item to the list
      activeFilters = activeFilters.concat([renderActiveFilter('Clear filters', removeFilters)]);

      // this is an array of <button>s with labels and remove methods
      return _react2.default.createElement(
        'div',
        { styleName: 'active-filters' },
        _react2.default.createElement(
          'div',
          { styleName: 'active-filters-label' },
          'Active filters:'
        ),
        activeFilters.map(function (e, i) {
          return e;
        })
      );
    }
  }]);
  return IyvListActiveFilters;
}(_react.Component), _class2.propTypes = {
  searchQuery: _react.PropTypes.string,
  removeFilter: _react.PropTypes.func,
  removeFilters: _react.PropTypes.func,
  removeSearchFilter: _react.PropTypes.func,
  selectedFilters: _react.PropTypes.object,
  filterOptions: _react.PropTypes.func,
  defaultFilter: _react.PropTypes.string
}, _temp)) || _class);
exports.default = IyvListActiveFilters;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListFilters/IyvListActiveFilters.js
// module id = 1352
// module chunks = 0